import { Select, SelectProps } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

type PropertyType<T, K extends keyof T> = T[K]

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    SelectProps {
  options: Array<{
    label: string
    value: PropertyType<T, K>
  }>
}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    options,
    variant,
    ...rest
  } = props

  let optionStyle = {}
  switch (variant) {
    case 'dark0-modal':
      optionStyle = {
        backgroundColor: '#333',
        color: 'white',
      }
      break

    default:
      break
  }

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => {
        useEffect(() => {
          if (value === undefined) onChange(options[0].value)
        }, [value])

        return (
          <Select onChange={onChange} value={value} variant={variant} {...rest}>
            {options.map((option) => (
              <option
                key={`${option.label}-${option.value}`}
                value={option.value}
                style={optionStyle}
              >
                {option.label}
              </option>
            ))}
          </Select>
        )
      }}
    />
  )
}
